export const gamesGeneralInfoMocked = {
  26422400: {
    id: 26422400,
    team1_id: 907380,
    team2_id: 794937,
    team1_name: 'Manchester City (Thomas)',
    team2_name: 'Bayern Munich (Stephan)',
    info: {
      current_game_state: 'finished',
      current_game_time: '90',
      add_minutes: '0',
      stoppage_firsthalf: '02:00',
      stoppage_secondhalf: '05:00',
      score1: '1',
      score2: '4',
      pass_team: 'none',
      shirt1_color: '000000',
      shirt2_color: '000000',
      short1_color: '000000',
      short2_color: '000000',
      field: 0,
      add_info: '',
      horse_xml: {
        Status: null,
        RacingId: 0,
        HorceCXml: null,
        HorceBXml: null
      },
      virtual: '',
      periods_values: { 1: [1] },
      period_points_home_d: [1],
      period_points_away_d: [1],
      period_points_home: [1],
      period_points_away: [1],
      home_total: 0,
      away_total: 0
    },
    stats: {
      team1_value: '',
      team2_value: '',
      add_info: null
    },
    start_ts: 1737693000,
    type: 2,
    is_blocked: 0,
    text_info: '1 : 4, (0:1), (1:3); FT',
    game_number: 106272,
    sport_alias: 'CyberFootball',
    is_live: 0,
    is_stat_available: true,
    _parent_id: 18272809,
    region_alias: 'Europe',
    sportName: 'E-Football',
    sportId: 71,
    regionAlias: 'Europe',
    regionName: 'Europe',
    competitionName: 'Champions league',
    competitionId: 18272809,
    tv_type: null,
    video_id: null,
    video_id2: null,
    is_feed_available: false,
    sportcast_id: 452454245,
    show_type: ''
  }
};

export const gameForMobile = {
  id: 26422400,
  type: 2,
  start_ts: 1737693000,
  region_alias: 'Europe',
  sportName: 'E-Football',
  game_number: 106272,
  sport_alias: 'CyberFootball',
  is_live: 0,
  is_stat_available: true,
  is_started: 0,
  is_blocked: 0,
  events_count: null,
  team1_id: 907380,
  team2_id: 794937,
  team1_name: 'Manchester City (Thomas)',
  team2_name: 'Bayern Munich (Stephan)',
  text_info: '1 : 4, (0:1), (1:3); FT',
  sportcast_id: 0,
  stats: {
    team1_value: '',
    team2_value: '',
    add_info: null
  },
  live_events: [
    {
      event_type: '',
      team: 'team2',
      add_info: null,
      event_value: undefined
    }
  ],
  is_feed_available: false,
  last_event: '',
  express_min_len: null,
  exclude_ids: null,
  tv_type: null,
  video_id: null,
  video_id2: null,
  promoted: '',
  descr: 'comp_country',
  visible_in_prematch: 0,
  show_type: '',
  shirt1_color: '000000',
  shirt2_color: '000000',
  competitionName: 'Champions league',
  match_length: '',
  info: {
    current_game_state: 'finished',
    current_game_time: '90',
    add_minutes: '0',
    stoppage_firsthalf: '02:00',
    stoppage_secondhalf: '05:00',
    score1: '1',
    score2: '4',
    pass_team: 'none',
    shirt1_color: '000000',
    shirt2_color: '000000',
    short1_color: '000000',
    short2_color: '000000',
    field: 0,
    add_info: '',
    horse_xml: {
      Status: null,
      RacingId: 0,
      HorceCXml: null,
      HorceBXml: null
    },
    virtual: '',
    periods_values: { 1: [1] },
    period_points_home_d: [1],
    period_points_away_d: [1],
    period_points_home: [1],
    period_points_away: [1],
    home_total: 0,
    away_total: 0
  }
};
